export default __webpack_public_path__ + "static/media/abreAniversario.cdd3f4c0.jpg";